import React, { useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import rightArrow from '../../images/arrow-right-white.svg';
import rightArrowBlue from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.genericCtaBannerWithMultipleLayoutComponent.scss';
import MarketoFormComponent from '../marketo/marketoFormComponent';

const GenericCtaBannerWithMultipleLayoutComponent = ({ data }) => {

    const [marketoFormShow, setMarketoFormShow] = useState(false);
    const showMarketoForm = (val) => {
        setMarketoFormShow(val);
    }

    return (
        <div data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" className={`cp-ctaWithMultipleLayoutComponent ${data.genericCtaBannerWithmultipleLayoutType}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-ctaWithMultipleLayoutComponent__inner l--flex" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                {data.genericCtaBannerWithmultipleLayoutType === 'layout1' ?
                    <>
                        <div className="cp-ctaWithMultipleLayoutComponent__left">
                            {data.genericCtaBannerWithmultipleLayoutImage &&
                                <>
                                    <div className="l--desktopOnly">
                                        <GatsbyImage image={getImage(data.genericCtaBannerWithmultipleLayoutImage.gatsbyImage)} alt={data.genericCtaBannerWithmultipleLayoutImage.altText} />
                                    </div>
                                    <div className="l--mobileOnly">
                                        {data.genericCtaBannerWithmultipleLayoutImageMobile &&
                                            <GatsbyImage image={getImage(data.genericCtaBannerWithmultipleLayoutImageMobile.gatsbyImage)} alt={data.genericCtaBannerWithmultipleLayoutImageMobile.altText} />
                                        }
                                    </div>
                                </>
                            }
                        </div>
                        <div className="cp-ctaWithMultipleLayoutComponent__right dd">
                            {data.genericCtaBannerWithmultipleLayoutLink &&
                                <div className="l--flex">
                                    <div className="l-relativeButton">
                                        <a className="l-button" href={data.genericCtaBannerWithmultipleLayoutLink.url} target={data.genericCtaBannerWithmultipleLayoutLink.target}>
                                            <span>{data.genericCtaBannerWithmultipleLayoutLink.title}</span>
                                            <img src={rightArrow} alt="" />
                                        </a>
                                        <a className="l-button l-backgroundHover" href={data.genericCtaBannerWithmultipleLayoutLink.url} target={data.genericCtaBannerWithmultipleLayoutLink.target}>
                                            <span>{data.genericCtaBannerWithmultipleLayoutLink.title}</span>
                                            <img src={rightArrow} alt="" />
                                        </a>
                                    </div>
                                    {data.genericCtaBannerWithmultipleLayoutLinkTwo &&
                                        <div className="l-relativeButton">
                                            <a className="l-button" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                <img src={rightArrow} alt="" />
                                            </a>
                                            <a className="l-button l-backgroundHover" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                <img src={rightArrow} alt="" />
                                            </a>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </>
                    :
                    <>
                        <div className="cp-ctaWithMultipleLayoutComponent__left">
                            {data.genericCtaBannerWithmultipleLayoutImage &&
                                <GatsbyImage image={getImage(data.genericCtaBannerWithmultipleLayoutImage.gatsbyImage)} alt={data.genericCtaBannerWithmultipleLayoutImage.altText} />
                            }
                        </div>
                        <div className="cp-ctaWithMultipleLayoutComponent__right">
                            {data.genericCtaBannerWithmultipleLayoutHeader &&
                                <h2>{data.genericCtaBannerWithmultipleLayoutHeader}</h2>
                            }
                            {data.genericCtaBannerWithmultipleLayoutTeaser &&
                                <p dangerouslySetInnerHTML={{ __html: data.genericCtaBannerWithmultipleLayoutTeaser }} />
                            }
                            {data.genericCtaBannerWithmultipleLayoutLink &&
                                <>
                                    {data.genericCtaBannerWithmultipleLayoutLink.url === '#marketo' || data.genericCtaBannerWithmultipleLayoutLink.url === '#marketopowerbi' ?
                                        <div className="l--flex">
                                            <div className="l-relativeButton" onClick={() => showMarketoForm(true)}>
                                                <button class="l-button">
                                                    <span>Connect With Your Account Manager</span>
                                                    <img src={rightArrow} alt="" />
                                                </button>
                                                <button class="l-button l-backgroundHover">
                                                    <span>Connect With Your Account Manager</span>
                                                    <img src={rightArrow} alt="" />
                                                </button>
                                            </div>
                                            {data.genericCtaBannerWithmultipleLayoutLinkTwo &&
                                                <div className="l-relativeButton">
                                                    <a className="l-button" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                        <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                        <img src={rightArrowBlue} alt="" />
                                                    </a>
                                                    <a className="l-button l-backgroundHover" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                        <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                        <img src={rightArrow} alt="" />
                                                    </a>
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div className="l--flex">
                                            <div className="l-relativeButton">
                                                <a className="l-button" href={data.genericCtaBannerWithmultipleLayoutLink.url} target={data.genericCtaBannerWithmultipleLayoutLink.target}>
                                                    <span>{data.genericCtaBannerWithmultipleLayoutLink.title}</span>
                                                    <img src={rightArrow} alt="" />
                                                </a>
                                                <a className="l-button l-backgroundHover" href={data.genericCtaBannerWithmultipleLayoutLink.url} target={data.genericCtaBannerWithmultipleLayoutLink.target}>
                                                    <span>{data.genericCtaBannerWithmultipleLayoutLink.title}</span>
                                                    <img src={rightArrow} alt="" />
                                                </a>
                                            </div>
                                            {data.genericCtaBannerWithmultipleLayoutLinkTwo &&
                                                <div className="l-relativeButton">
                                                    <a className="l-button" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                        <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                        <img src={rightArrowBlue} alt="" />
                                                    </a>
                                                    <a className="l-button l-backgroundHover" href={data.genericCtaBannerWithmultipleLayoutLinkTwo.url} target={data.genericCtaBannerWithmultipleLayoutLinkTwo.target}>
                                                        <span>{data.genericCtaBannerWithmultipleLayoutLinkTwo.title}</span>
                                                        <img src={rightArrow} alt="" />
                                                    </a>
                                                </div>
                                            }
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </>
                }

                {marketoFormShow &&
                    <div className="cp-postPerformEventIntro__formVideo l--flex l--abtestOverride">
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            {data.genericCtaBannerWithmultipleLayoutLink &&
                                <>
                                    {data.genericCtaBannerWithmultipleLayoutLink.url === '#marketopowerbi' ?
                                        <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3702" />
                                        :
                                        <MarketoFormComponent formSubmitMessage="Thank you for your submission" formId="3714" />
                                    }
                                </>
                            }
                            <button onClick={() => showMarketoForm(false)} className="l-backgroundTrigger"></button>
                        </div>
                    </div>
                }

            </div>
        </div>
    );
}

export default GenericCtaBannerWithMultipleLayoutComponent;